import { collection, doc, getDoc, setDoc, updateDoc } from "firebase/firestore"
import { db } from "../app/App"
import { StorageKeys } from "../constants"
import { Agent } from "../types/Agent"
import { Call } from "../types/Call"
import { Collections } from "../types/Db"
import { User } from "../types/User"
import { isAnonymous } from "../utils/func"

export const addCallDb = async (
  user: User,
  agentId: string,
  agent: Agent,
): Promise<string> => {
  const id = doc(collection(db, Collections.calls)).id
  const conversationRef = doc(db, Collections.calls, id)

  let userName = user.name
  let userEmail = user.email

  if (isAnonymous()) {
    const anonName = localStorage.getItem(StorageKeys.ANON_NAME)
    const anonEmail = localStorage.getItem(StorageKeys.ANON_EMAIL)

    userName = anonName || user.name
    userEmail = anonEmail || user.email
  }

  const conversation = {
    startedAt: new Date(),
    createdAt: new Date(),
    updatedAt: new Date(),
    creatorId: agent.creatorId,
    userId: user.uid,
    userName,
    userEmail,
    userPhotoUrl: user.photoURL || "",
    agentId,
  }
  await setDoc(conversationRef, conversation)
  return id
}

export const updateCallDb = async (call: Call): Promise<void> => {
  const conversationRef = doc(db, Collections.calls, call.id)
  await setDoc(conversationRef, call, { merge: true })
}

export const endCallDb = async (callId: string): Promise<void> => {
  const conversationRef = doc(db, Collections.calls, callId)
  await updateDoc(conversationRef, {
    sendTranscriptToUser: true,
    updatedAt: new Date(),
  })
}

export const updateCallDuration = async (
  callId: string,
  additionalData?: Partial<Call>,
) => {
  try {
    const callRef = doc(db, Collections.calls, callId)
    if (callRef) {
      await updateDoc(callRef, {
        ...additionalData,
      })
    }
  } catch (error) {
    console.error(error)
    return false
  }
}

export const getCall = async (callId: string): Promise<Call | null> => {
  const callRef = doc(db, Collections.calls, callId)
  const callDoc = await getDoc(callRef)
  if (!callDoc.exists()) return null
  return callDoc.data() as Call
}

export const getCallDuration = async (callId: string): Promise<number> => {
  const callRef = doc(db, Collections.calls, callId)
  const callDoc = await getDoc(callRef)
  if (!callDoc.exists()) return null
  return callDoc.data()?.callDuration || 0
}

export const checkCallExists = async (callId: string): Promise<boolean> => {
  const callRef = doc(db, Collections.calls, callId)
  const callDoc = await getDoc(callRef)
  return (
    callDoc.exists() &&
    callDoc.data() !== null &&
    Object.keys(callDoc.data()).length > 0
  )
}
